import React, { Component } from "react";
import ProgressBar from "../progress-bar/progress-bar.component.js";

const ContentHeader = (props) => {
  return (
    props.show == true && (
      <div className="container content-header app-container">
        <div className="row">
          <div className="col-12">
            <h1>{props.headerTitle}</h1>
            <p>{props.headerContent}</p>
            <ProgressBar show={props.showProgressBar} />
          </div>
        </div>
      </div>
    )
  );
};

export default ContentHeader;



// WEBPACK FOOTER //
// ./src/components/content-header/content-header.component.js